import { useContext } from 'react';
import { TwilioContext } from '../../TwilioProvider';

/**
 * Make TwilioProvider easily consumable via useContext,
 * while ensuring consumers are descendants of the provider.
 */
export const useTwilio = () => {
  const context = useContext(TwilioContext);
  if (context === undefined)
    throw new Error('useTwilio must be used within a TwilioProvider');

  return context;
};
